// extracted by mini-css-extract-plugin
var _1 = "DialogFooter_dialogFooter__WKaPi";
export { _1 as "dialogFooter" }
